/**
 * Centralised TanStack Query keys for the attribute dictionary. Mutations
 * invalidate `all`, which covers both the types list and the pending queue.
 */
export const AttributeQueryKeys = {
    all: ['attributeTypes'] as const,
    list: () => [...AttributeQueryKeys.all, 'list'] as const,
    pending: () => [...AttributeQueryKeys.all, 'pending'] as const,
};
